import gql from 'graphql-tag';

const LOCATION_DETAIL_FRAGMENT_MOBILE = gql`
    fragment locationDetailMobile on Location {
        id
        name
        accessHours 
        directions
        visualDirectionPhotos {
            id
            link
            comment
        }
        visualDirectionPhotoUrls
        requiresAccessPass
        requiresSignIn
        signInInstructions
        client {
            id
            name
        }
        person {
            id
            name
        }
        secondaryPerson {
            id
            name
        }
        coordinates
        address
        addressObj {
        id
        region
        street
        city
        postcode
        }
    }
`;

export const GET_LOCATION_DETAIL_MOBILE = gql`
    query($id: String) {
        getLocation(id: $id) {
            ...locationDetailMobile
        }
    }
    ${LOCATION_DETAIL_FRAGMENT_MOBILE}
`;

export const MODIFY_LOCATION_MOBILE = gql`
    mutation modifyLocationMutation($input: ModifyLocationInput!) {
        modifyLocation(input: $input) {
            location {
                ...locationDetailMobile
            }
        }
    }
    ${LOCATION_DETAIL_FRAGMENT_MOBILE}
`;

export const SUBSCRIBE_TO_LOCATION_MOBILE = gql`
    subscription ($input: LocationSubscriptionInput!) {
        LocationSubscription(input: $input) {
            location {
                ...locationDetailMobile
            }
            destroyedLocationId
        }
    }
    ${LOCATION_DETAIL_FRAGMENT_MOBILE}
`;
